export default __webpack_public_path__ + "static/media/a2b_logo.e5db6d21.svg";